import React, { useState, useRef, useEffect } from "react";
import { useLanguage } from "../../../context/LanguageContext";
import "./SortDropdownShop.css";

const SortDropdownShop = ({ selectedOption, onSortChange }) => {
    const { language } = useLanguage();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    // Translations for sort options
    const translations = {
        en: {
            sortBy: "SORT BY:",
            featured: "Featured",
            newIn: "New In",
            priceHighToLow: "Price (high to low)",
            priceLowToHigh: "Price (low to high)"
        },
        ar: {
            sortBy: "ترتيب حسب:",
            featured: "مميز",
            newIn: "وصل حديثاً",
            priceHighToLow: "السعر (من الأعلى إلى الأقل)",
            priceLowToHigh: "السعر (من الأقل إلى الأعلى)"
        }
    };

    const t = translations[language] || translations.en;

    const options = [
        { label: t.featured, value: "Recommended" },
        { label: t.newIn, value: "New Product" },
        { label: t.priceHighToLow, value: "Price high to low" },
        { label: t.priceLowToHigh, value: "Price low to high" },
    ];

    useEffect(() => {
        const close = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", close);
        return () => document.removeEventListener("mousedown", close);
    }, []);

    return (
        <div className="sort-dropdown" ref={ref}>
            <span className="sort-text">{t.sortBy}</span>
            <span
                className="sort-selected-clickable"
                onClick={() => setOpen(!open)}
            >
                {options.find((opt) => opt.value === selectedOption)?.label}
                <i className={`fa-solid fa-chevron-${open ? "up" : "down"}`}></i>
            </span>

            {open && (
                <div className="sort-dropdown-menu">
                    {options.map((opt) => (
                        <div
                            key={opt.value}
                            className={`sort-item ${selectedOption === opt.value ? "active" : ""}`}
                            onClick={() => {
                                onSortChange(opt.value);
                                setOpen(false);
                            }}
                        >
                            {opt.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SortDropdownShop;
